export const render = async () => {
  await import('./i18n/i18n');

  const { init } = await import('./app');

  init();

  await import('./core/services/errorController');
};

render().then(() => {});
